import { thunk } from 'easy-peasy'
import type { Thunk } from 'easy-peasy'
import type { FMPStoreModel } from '../../types'
import { initializeRvUserType, setupStrataUtils } from '@strata-monorepo/utils/rvUserType'

export interface AppModel {
  // Thunks
  initApp: Thunk<AppModel, void, null, FMPStoreModel>
}

const appModel = (): AppModel => {
  return {
    // Thunks
    initApp: thunk(async (actions, _, { getStoreActions }) => {
      if (!window) {
        return
      }

      const storeActions = getStoreActions()

      // Initialize RV user type and setup window utilities
      initializeRvUserType()
      setupStrataUtils()

      // Initialize logger/New Relic
      storeActions.logger.bootstrapLogger()

      // Initialize metrics client
      storeActions.metrics.bootstrapMetricsClient()
    }),
  }
}

export default appModel
